import { BlocksTable } from 'blocks-nextjs/blocks-web-components/components/table/table';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTable = createComponent({ react: React, tagName: 'cat-table', elementClass: BlocksTable });
